import { LookupService } from '../../shared/services/lookup.service';
import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { Subscription } from 'rxjs';
import { JobseekerService } from '../shared/services/jobseeker.service';
import { JobseekerModel } from '../shared/models/jobseeker-model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { CustomMessageService } from '@admin/core/message.service';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-jobseeker-view-edit',
  templateUrl: './jobseeker-view-edit.component.html',
  host: {
    '(window:keydown)': 'hotkeys($event)',
  },
  styleUrls: ['./jobseeker-view-edit.component.less'],
  standalone: false,
})
export class JobseekerViewEditComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  constructor(
    private jobseekerService: JobseekerService,
    private route: ActivatedRoute,
    private router: Router,
    private lookupService: LookupService,
    private config: ConfigurationService,
    private translationService: TranslateService,
    private messageService: CustomMessageService
  ) {
    this.drivingLicensesInput = [];
    this.localities = [];
    this.monthList = [];
    this.yearList = [];
    this.genderList = [];
    this.languageproficiencyLevelList = [];
    this.worldLanguages = [];

    this.activeEvents = [];
    this.switchFilterStates = [
      {
        label: this.translationService.instant('label.Profile'),
        value: SwitchFilterState.Profile,
      },
      {
        label: this.translationService.instant('label.Subscriptions'),
        value: SwitchFilterState.Subscription,
      },
    ];
    this.selectedSwitchFilterState = SwitchFilterState.Profile;
  }

  private jobseekerId: number;

  public jobseeker: JobseekerModel;

  private sub: Subscription;

  public drivingLicensesInput: CommonLookupItem<number, string>[];
  public monthList: CommonLookupItem<number, string>[];
  public yearList: CommonLookupItem<number, string>[];
  public genderList: CommonLookupItem<number, string>[];
  public localities: CommonLookupItem<number, string>[];
  public languageproficiencyLevelList: CommonLookupItem<number, string>[];
  public worldLanguages: CommonLookupItem<number, string>[];

  public activeEvents: CommonLookupItem<any, any>[];

  public switchFilterState = SwitchFilterState;
  public selectedSwitchFilterState: SwitchFilterState;
  public switchFilterStates: SelectItem[];

  public locationLevelCount: number;
  public locationFirstLevelId: string;
  public locationRootId: string;
  public jobseekerLocationRequiredLevelCount: number;
  public jobseekerLocationLastHiddenLevelCount: number;

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    this.drivingLicensesInput = lookupData.drivingLicenses;
    this.localities = lookupData.localities;
    this.monthList = lookupData.monthListFull;
    this.yearList = lookupData.yearListBirth;
    this.genderList = lookupData.genderList;
    this.languageproficiencyLevelList = lookupData.languageProficiencyLevelList;
    this.worldLanguages = lookupData.worldLanguages;

    let configs = this.config.getCachedConfig();
    this.locationLevelCount = configs.locationLevelCount;
    this.locationFirstLevelId = configs.locationFirstLevelId;
    this.locationRootId = configs.locationRootId;
    this.jobseekerLocationRequiredLevelCount =
      configs.jobseekerLocationRequiredLevelCount;
    this.jobseekerLocationLastHiddenLevelCount =
      configs.jobseekerLocationLastHiddenLevelCount;

    this.sub = this.route.params.subscribe((p) => {
      let jobseekerId = +p['id'];
      this.jobseekerId = jobseekerId;
      this.jobseekerService.getJobseeker(jobseekerId).subscribe((d) => {
        if (d.success) {
          this.jobseeker = d.payload;

          this.jobseekerService.listActiveEvents().subscribe((dd) => {
            this.activeEvents = dd;
            this.activeEvents.forEach((c) => {
              c.isDisabled = this.jobseeker.visitedEvents.some(
                (cc) => c.value == cc.eventId
              );
            });
          });
        } else {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translationService.instant('message.' + d.error),
          });
        }
      });
    });
  }

  public load() {
    this.jobseekerService.getJobseeker(this.jobseekerId).subscribe((d) => {
      this.jobseeker = d.payload;
      this.jobseekerService.listActiveEvents().subscribe((d) => {
        this.activeEvents = d;
        this.activeEvents.forEach((c) => {
          c.isDisabled = this.jobseeker.visitedEvents.some(
            (cc) => c.value == cc.eventId
          );
        });
      });
    });
  }

  public onRegisterOnEventClick(event: CommonLookupItem<any, any>) {
    let result = confirm(this.translationService.instant('message.AreYouSure'));

    if (result) {
      this.jobseekerService
        .registerOnEvent(this.jobseeker.jobseekerId, event.value)
        .subscribe((d) => {
          this.load();
        });
    }
  }

  public onJobseekerBasicInfoUpdate(event: any) {
    //alert('saved');
    this.load();
  }

  public onJobseekerWorkExperienceInfoUpdate(event: any) {
    //alert('saved');
    this.load();
  }

  public onJobseekerDetailsUpdate(event: any) {
    this.load();
  }

  public onJobseekerEducationInfoUpdate(event: any) {
    this.load();
  }

  public onEditClick() {}

  public onJobseekerLanguageInfoUpdate(event: any) {
    this.load();
  }

  public onJobseekerUploadedDocumentUpdate(event: any) {
    this.load();
  }

  public hotkeys(event: any) {
    console.log(event);

    if (event.code == 'KeyJ' && event.altKey && !event.repeat) {
      let jobseekerId = prompt('Jobseeker Id:');
      console.log(jobseekerId);
      this.router.navigate(['../../edit', jobseekerId], {
        relativeTo: this.route,
      });
    }
  }
}

enum SwitchFilterState {
  Profile = 1,
  Subscription = 2,
}
